export enum StepperType {
  Tender = 'TENDER_STEPPER',
  Bid = 'BID_STEPPER',
  MultipleBid = 'MULTIPLE_BID_STEPPER',
}

export const HideAlertOnBidDashboard = 'HIDE_ALERT_ON_BID_DASHBOARD'

export const CookieConsentStorageKey = 'COOKIE_CONSENT'

// Values match Google Consent Mode states
export enum CookieConsentStatus {
  Granted = 'granted',
  Denied = 'denied',
}
